import React from "react";
import content from "../utils/content.json";

function Skills() {
  const skills = content.content.skills.skills;
  const midPoint = Math.ceil(skills.length / 2);
  const leftColumn = skills.slice(0, midPoint);
  const rightColumn = skills.slice(midPoint);

  return (
    <section id="skills" className="container section">
      <h2 id="resume_header" className="section__title">
        {content.content.skills.title}
      </h2>
      <div className="row section__resume progress-list js-progress-list">
        <div className="col-md-6">
          {leftColumn.map((skill, index) => (
            <div key={index} className="progress-list__skill">
              <p>
                <span className="progress-list__skill-title">
                  {skill.skills.map((skill) => skill).join(" | ")}
                </span>
              </p>
              <div className="progress">
                <div
                  className="progress-bar"
                  style={{ width: "100%" }}
                  role="progressbar"
                  aria-valuenow="80"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            </div>
          ))}
        </div>
        <div className="col-md-6">
          {rightColumn.map((skill, index) => (
            <div key={index} className="progress-list__skill">
              <p>
                <span className="progress-list__skill-title">
                  {skill.skills.map((skill) => skill).join(" | ")}
                </span>
              </p>
              <div className="progress">
                <div
                  className="progress-bar"
                  style={{ width: "100%" }}
                  role="progressbar"
                  aria-valuenow="80"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Skills;
